const MODEL_FAMILY_OTHER_SUFFIX = '-MODELFAMILY_OTHER';

// Mirrors the bounded API validation for catalogue model-family codes.
// eslint-disable-next-line security/detect-unsafe-regex
const MODEL_FAMILY_PATTERN = /^MAKE_[A-Z]+(?:[_-][A-Z]+)?-MODELFAMILY(?:[_-][A-Z0-9]+)+$/;

interface ApiModelFamilyFieldsInput {
  make: string;
  modelFamily?: string | null;
  formModelFamily?: string | null;
  customModelFamily?: string | null;
}

export const toApiModelFamilyFields = (input: ApiModelFamilyFieldsInput) => {
  const selectedModelFamily = input.formModelFamily ?? input.modelFamily ?? '';
  const isCustomModel =
    selectedModelFamily.length > 0 &&
    (input.customModelFamily === selectedModelFamily ||
      !MODEL_FAMILY_PATTERN.test(selectedModelFamily));

  return {
    modelFamily: isCustomModel ? `${input.make}${MODEL_FAMILY_OTHER_SUFFIX}` : selectedModelFamily,
    customModelFamily: isCustomModel ? selectedModelFamily : null,
  };
};
